import React, { Component } from 'react';
import DataStore from '../../stores/DataStore';
import { Link } from 'react-router-dom';

import styles from './about.css';

import SlideShow from '../../components/SlideShow/SlideShow';
import AboutHelmet from './Helmet';

class About extends Component {

	constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.data = DataStore.getPageBySlug('about');
    this.match = this.props.match;
  }

	render() {
    const { summary, about_portaits } = this.data.acf;
    const d = new Date();
    const Y = d.getFullYear().toString();

		return (
	    <section className={styles.wrapper}>
      <AboutHelmet title={this.data.title.rendered} />
      <div className={styles.content}>
        <div className={styles.grid}>
          <div className={styles.gridItem}>
            <SlideShow>
              {
                about_portaits.map((item, index) =>
                  <img
                    key={index}
                    data-sizes="auto"
                    src={item.sizes.medium}
                    data-srcset={[
                      `${item.sizes.medium_large} 300w`,
                      `${item.sizes.large} 600w`,
                      `${item.url} 900w`
                    ]}
                    className={`${styles.slideShowItem} lazyload`}
                   />
                )
              }
            </SlideShow>
          </div>
          <div className={styles.gridItem}>
            <div className={styles.align}>
              <div className={styles.details}>
                <div className={styles.summaryContent} dangerouslySetInnerHTML={{ __html: summary }} />
                <div className={styles.bodyContent} dangerouslySetInnerHTML={{ __html: this.data.content.rendered }} />
              </div>
              <p className={styles.copyright}>&copy; { Y } &mdash; Regis Biron all rights reserved.</p>
            </div>
          </div>
        </div>
        <Link className={styles.closeLink} to="/">
          <div className={styles.closeButton} />
        </Link>
      </div>
	    </section>
		);
	}
}

export default About;



// WEBPACK FOOTER //
// ./src/views/About/About.js